import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import type { FlagProps } from '../types';
import classes from '../flagpack.module.css';

export function PGFlag({ radius, className, size, ...others }: FlagProps) {
  return (
    <Box
      className={cx(classes.flag, className)}
      __vars={{ '--flag-radius': getRadius(radius), '--flag-size': rem(size) }}
      {...others}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
        <mask id="mantine-038iew36t" fill="#fff">
          <path fillRule="evenodd" d="M0 0h32v24H0z" />
        </mask>
        <g fill="none" fillRule="evenodd" mask="url(#mantine-038iew36t)">
          <rect width="32" height="24" fill="#e11c1b" rx="2" />
          <path fill="#1d1d1d" d="M0 0l32 24H0z" />
          <g fill="#eeeef6">
            <path d="M7.083 18.268h1.332l.634-1.493.744 1.483 1.365.075-1.167 1.27.6 1.528-1.483-.85-1.369.858.517-1.485zm-4-4h1.332l.634-1.493.744 1.483 1.365.075-1.167 1.27.6 1.528-1.483-.85-1.369.858.517-1.485zm4-2h1.332l.634-1.493.744 1.483 1.365.075-1.167 1.27.6 1.528-1.483-.85-1.369.858.517-1.485z" />
            <path d="M9.711 16.564l.916-.03.33-.944.371.939.843.08-.759.537.612.95-1.062-.397-.92.41.486-.937zm2-2l.916-.03.33-.944.371.939.843.08-.759.537.612.95-1.062-.397-.92.41.486-.937z" />
          </g>
          <path
            fill="#fbcd17"
            d="M21.084 2c-2.06.41-2.8 2.047-2.222 4.91h-.44c.023-.15-.106-.268-.388-.356-.424-.13-.34-.082-.558 0-.145.055-.662.055-1.549 0v.165l.942.406c-.016.226.108.401.37.526s.489.218.68.278c.038.25-.065.374-.311.374-.369 0-1.852-.48-2.38.7A9.204 9.204 0 0114 11.051h.79l-.211.264h.89l-.24.136c.734-.008 1.13-.053 1.187-.136.057-.083.057.03 0 .337.712-.325 1.087-.525 1.126-.601l.498.342.142-.579.535.237.145-.551c1.008 1.686 1.894 2.48 2.659 2.384v-.42l1.046.42.133-.187c.843.344 1.394.531 1.654.563l-.278-.563h.278l-.278-1.045h.278l-.555-.838.155-.226-.103-.298c1.357.432 2.005.992 1.944 1.68-.061.687-.394 1.17-.998 1.448a4.51 4.51 0 01-1.655.209c.416.49 1.063.653 1.942.486.88-.166 1.465-.675 1.756-1.528.403.838.439 1.476.107 1.917-.332.44-1.237.815-2.714 1.124.534.313 1.055.43 1.562.35.76-.121 1.943-.783 2.172-1.863.23-1.08-.79-3.072-1.253-3.299l-.183-.69.416.166-.852-2.085.413.09-1.206-1.5.332-.102-1.666-1.197.498-.132c-.82-.416-1.7-.372-2.636.132l.013-.261-.369.062.022-.287.367-.556-.55-.212c.296-.446.422-.666.378-.66-.331.095-.487.122-.469.083.167-.43.229-.64.185-.628-.384.13-.547.163-.49.098l.22-.394z"
          />
        </g>
      </svg>
    </Box>
  );
}
